module.exports = __webpack_public_path__ + "img/dubby.26bcc51d.png";